import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67878ca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-blue-primary rounded-md mb-5"
}
const _hoisted_2 = { class: "text-center p-3" }
const _hoisted_3 = { class: "text-center text-white text-sm" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Update profile image  ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add Image ")
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "flex flex-row items-center" }
const _hoisted_9 = { class: "ml-2 pt-2" }
const _hoisted_10 = { class: "text-gray-text" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-white mb-5" }, "PERSONAL INFORMATION", -1))
const _hoisted_13 = { class: "md:flex mb-3 items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "first-name",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, "First Name", -1))
const _hoisted_15 = { class: "md:flex mb-3 items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "last-name",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, "Last name", -1))
const _hoisted_17 = { class: "md:flex mb-3 items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "username",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, "Username", -1))
const _hoisted_19 = { class: "md:flex mb-3 items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "email",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, "Email", -1))
const _hoisted_21 = { class: "md:flex mb-3 items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Gender", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Male" }, "Male", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Female" }, "Female", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Other" }, "Other", -1))
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "md:flex mb-3 items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Country", -1))
const _hoisted_29 = { class: "flex-grow" }
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-white my-5 uppercase" }, "Social Media Links", -1))
const _hoisted_32 = { class: "md:flex mb-3 items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "website",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, "Personal Website", -1))
const _hoisted_34 = { class: "md:flex mb-3 items-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "discord",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, [
  /*#__PURE__*/_createTextVNode("Discord ID "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(18-numeric)")
], -1))
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = {
  class: "mt-1 text-gray-400",
  style: {"font-size":"10px"}
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode("https://discord.com/users/")
const _hoisted_39 = { class: "font-bold" }
const _hoisted_40 = { class: "md:flex mb-3 items-center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  for: "discord",
  class: "text-white text-sm w-36 my-2 md:my-0"
}, "Twitter Username", -1))
const _hoisted_42 = { class: "flex flex-col" }
const _hoisted_43 = {
  class: "mt-1 text-gray-400",
  style: {"font-size":"10px"}
}
const _hoisted_44 = /*#__PURE__*/_createTextVNode("https://twitter.com/")
const _hoisted_45 = { class: "font-bold" }
const _hoisted_46 = { class: "md:flex mb-5" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-36" }, null, -1))
const _hoisted_48 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isDisplayUploadUserImageLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fileInput.click())),
                class: "border border-blue-900 p-1 px-2 bg-blue-900 hover:bg-blue-800 transition-all duration-200 rounded-md"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-camera",
                  class: "text-white inline-block mr-2"
                }),
                _hoisted_5
              ]),
              _createElementVNode("input", {
                style: {"display":"none"},
                ref: "fileInput",
                type: "file",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                accept: ".png, .jpg, .jpeg"
              }, null, 544),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateUserImage && _ctx.updateUserImage(...args))),
                  disabled: !_ctx.fileInput,
                  class: "mr-3 bg-success-check disabled:bg-gray-600 text-white p-1 px-2 hover:bg-green-700 duration-200 transition-all rounded-md"
                }, "Confirm", 8, _hoisted_7),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revertUserImage && _ctx.revertUserImage(...args))),
                  class: "hover:underline"
                }, "Cancel")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "inline-block border-black-border relative border rounded-full w-20 bottom-0 h-20 left-0 bg-cover bg-center bg-black-body",
        style: _normalizeStyle({ 'background-image': `url(${_ctx.image})` })
      }, [
        _createElementVNode("button", {
          class: "bg-black-body p-2 rounded-lg absolute",
          style: {"bottom":"0px","left":"0"},
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayUploadUserImageLabel = !_ctx.isDisplayUploadUserImageLabel))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-camera",
            class: "text-gray-text text-xl"
          })
        ])
      ], 4),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, "Username: " + _toDisplayString(_ctx.username), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border border-gray-500",
            id: "first-name",
            placeholder: "First name",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.strFirstName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.strFirstName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "last-name",
            placeholder: "Last name",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.strLastName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.strLastName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "username",
            placeholder: "Username",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.strUsername) = $event)),
            disabled: ""
          }, null, 512), [
            [_vModelText, _ctx.strUsername]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "email",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.strEmail) = $event)),
            placeholder: "Email",
            disabled: ""
          }, null, 512), [
            [_vModelText, _ctx.strEmail]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.strGender) = $event))
          }, _hoisted_26, 512), [
            [_vModelSelect, _ctx.strGender]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control text-white border-0",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.strUserCountry) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryList[0], (country) => {
              return (_openBlock(), _createElementBlock("option", {
                value: country.name,
                key: country.code
              }, _toDisplayString(country.name), 9, _hoisted_30))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.strUserCountry]
          ])
        ])
      ]),
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "website",
            placeholder: "www.yourWebsite.com",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.strUserWebsite) = $event))
          }, null, 512), [
            [_vModelText, _ctx.strUserWebsite]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            maxlength: "18",
            oninput: "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');",
            class: "form-control text-white border-0",
            id: "discord",
            placeholder: "18 Numeric Discord ID",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.strUserDiscord) = $event))
          }, null, 512), [
            [_vModelText, _ctx.strUserDiscord]
          ]),
          _createElementVNode("span", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.strUserDiscord), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "twitter",
            placeholder: "Twitter Username",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.strUserTwitter) = $event))
          }, null, 512), [
            [_vModelText, _ctx.strUserTwitter]
          ]),
          _createElementVNode("span", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.strUserTwitter), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn-primary",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.updateUserDetails && _ctx.updateUserDetails(...args))),
            disabled: _ctx.disabledSaveButton
          }, "Save Changes", 8, _hoisted_48)
        ])
      ])
    ])
  ]))
}